<template>
  <tr>
    <td v-text="item.attributes.title" />
    <td v-text="item.attributes.created" />
    <td v-text="status" />
    <td v-text="deletionIn" />
    <td>
      <a
        v-if="item.attributes.is_complete"
        class="btn btn--sm m-2"
        target="_blank"
        :href="downloadUrl"
        v-text="'Download'"
      />
      <span
        v-else
        v-text="'-'"
      />
    </td>
  </tr>
</template>

<script type="text/babel">
export default {
  name: 'ExportRow',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    downloadUrl() {
      return this.$urlGenerator.active(`exports/${this.item.uuid}/download`)
    },
    status() {
      return this.item.attributes.is_complete ? 'Complete' : 'Compiling'
    },
    deletionIn() {
      return this.item.attributes.deletion_in ? this.item.attributes.deletion_in : '-'
    },
  },
}
</script>
